/* eslint-disable arrow-body-style */
import React from 'react';

import { FilterPanelHeader } from '@src/common/FilterPanelPage/FilterPanelHeader';
import { LinkAnalysisBreadcrumbs } from './LinkAnalysisBreadcrumbs';
import { ValueField } from './filterPanelComponents/ValueField';
import { SearchButton } from './filterPanelComponents/SearchButton';
import { TypeSelect } from './filterPanelComponents/TypeSelect';
import { NodesSelect } from './filterPanelComponents/NodesSelect';
import { HopsSelect } from './filterPanelComponents/HopsSelect';
import { IpConnectionsField } from './filterPanelComponents/IpConnectionsField';

export const LinkAnalysisFilterPanel = () => {
  return (
    <React.Fragment>
      <LinkAnalysisBreadcrumbs />
      <FilterPanelHeader />
      <NodesSelect />
      <IpConnectionsField />
      <TypeSelect />
      <ValueField />
      <HopsSelect />
      <SearchButton />
    </React.Fragment>
  );
};
